import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "./Logo";

const Success = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-[#f8f7f2] p-3">
      <div className="w-full max-w-[702px] flex flex-col">
        <Logo />
        <div className="w-full bg-white rounded-lg shadow-sm border border-[#e7e6e3] flex-col justify-start items-start flex overflow-hidden">
          <div className="self-stretch p-4 justify-between items-center inline-flex">
            <div className="grow shrink basis-0 h-10 justify-start items-center gap-2 flex" />
            <div className="justify-start items-center gap-1 flex">
              <div className="w-8 h-8 bg-[#1b1a17] rounded-full border border-[#1b1a17] flex items-center justify-center">
                <div className="text-white text-base font-bold font-inter">1</div>
              </div>
              <div className="w-8 py-4 flex-col justify-start items-start gap-2.5 inline-flex">
                <div className="self-stretch h-px border border-[#1b1a17]" />
              </div>
              <div className="w-8 h-8 bg-[#1b1a17] rounded-full border border-[#1b1a17] flex items-center justify-center">
                <div className="text-white text-base font-bold font-inter">2</div>
              </div>
              <div className="w-8 py-4 flex-col justify-start items-start gap-2.5 inline-flex">
                <div className="self-stretch h-px border border-[#1b1a17]" />
              </div>
              <div className="w-8 h-8 bg-[#1b1a17] rounded-full border border-[#1b1a17] flex items-center justify-center">
                <div className="text-white text-base font-bold font-inter">3</div>
              </div>
            </div>
            <div className="grow shrink basis-0 h-10 justify-end items-center gap-2 flex" />
          </div>
          <div className="self-stretch px-4 pb-3 flex-col justify-start items-center gap-2 flex">
            <div className="self-stretch text-center text-[#0a0a08] text-xl font-semibold font-inter">You're All Set! 🎉</div>
            <div className="self-stretch text-center text-[#7a7871] text-sm font-normal font-inter">Get ready to absorb all of your newsletters with short, punchy digests!</div>
          </div>
          <div className="self-stretch p-4 flex-col gap-3">
            <div className="flex justify-between items-center">
              <button 
                onClick={() => navigate("/onboarding/select-categories")} 
                className="px-4 py-2 bg-white rounded-md border border-[#e7e6e3] justify-center items-center gap-2 flex">
                <ArrowLeft className="w-4 h-4" />
                <div className="text-[#1b1a17] text-sm font-medium font-inter">Back</div>
              </button>
              <button 
                onClick={() => navigate("/")}
                className="px-6 py-2.5 bg-[#14997e] rounded-md justify-center items-center gap-2 flex hover:bg-[#128b73] transition-colors">
                <div className="text-[#f9f9f9] text-base font-medium font-inter">Go to Dashboard</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
